import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../../defaults';
import { groupBy } from '../../../utils';
import { TeachersAdd } from './TeachersAdd';
import TeachersInfo from './TeachersInfo';
import TeachersSwitcher from './TeachersSwitcher';
import { Tabs, Row, Col, Select, TreeSelect, Empty, message } from 'antd';
import {
  getInstitutions,
  getInstitutionsType,
  getInstitutionByTypeId,
  getTeachersByInstitutionId,
  getTeacherById,
  getUnbinedClassesByInstitutionId,
  getAuthorizedPersonsProfile,
} from '../../../actions';
import { userRole } from '../../../common';

const { TabPane } = Tabs;
const { TreeNode } = TreeSelect;

const Teachers = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [classes, setClasses] = useState();

  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [edit, setEdit] = useState(false);

  const [institutionsType, setInstitutionsType] = useState();
  const [selectedInstitutionType, setSelectedInstitutionType] = useState();

  const [groupedInstitutions, setGroupedInstitutions] = useState({});
  const [institutions, setInstitutions] = useState();
  const [selectedInstitution, setSelectedInstitution] = useState();

  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState();

  useEffect(() => {
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));
    userRole() === 'admin' &&
      getInstitutions().then(({ data }) => {
        setInstitutions(data);
      });
    if ('director' === userRole()) {
      setLoading(true);
      getAuthorizedPersonsProfile()
        .then(({ data }) => {
          filterInstitutionsByTypeId(data?.institution?.institutionTypeId);
          setSelectedInstitution(data?.institution);
          onSelectInstitution(data?.institution?.id);
          setInstitutions([data?.institution]);
          setLoading(false);
        })
        .catch(() => {
          message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
          setLoading(false);
        });
    }
  }, []);

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  const filterInstitutionsByTypeId = (id) => {
    setLoading(true);
    if (!id) {
      setSelectedInstitutionType(null);
      setTeachers([]);
    } else {
      getInstitutionByTypeId(id).then((res) => {
        setSelectedInstitutionType(id);
        setGroupedInstitutions(groupBy(res.data, 'city'));
        'director' !== userRole() && setInstitutions(res.data);
      });
    }
    setSelectedInstitution(null);
    setSelectedTeacher(null);
    setLoading(false);
  };

  const onSelectInstitution = (id) => {
    setLoading(true);
    if (!id) {
      setSelectedInstitution(null);
      setTeachers([]);
    } else {
      getTeachersByInstitutionId(id).then(({ data }) => {
        'director' !== userRole() &&
          setSelectedInstitution(institutions.filter((x) => x.id == id)[0]);
        setTeachers(data);
      });
      getUnbinedClassesByInstitutionId(id).then(({ data }) => setClasses(data));
    }
    setSelectedTeacher(null);
    setLoading(false);
  };

  const onSelectTeacher = (id) => {
    setLoading(true);
    if (!id) {
      setSelectedTeacher(null);
    } else {
      getTeacherById(id)
        .then(({ data }) => setSelectedTeacher(data))
        .catch(() => {
          setSelectedTeacher();
          setLoading(false);
        });
    }
    setLoading(false);
  };

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddTeacher[language]}`} key="1">
        <TeachersAdd institutions={institutions} setActive={setActive} setAdded={setAdded} />
      </TabPane>
      <TabPane tab={dictionary?.TeacherList[language]} key="2">
        <Row style={{ marginTop: '30px' }} gutter={16}>
          <Col span={8}>
            <Select
              placeholder={dictionary?.InstitutionType[language]}
              size="large"
              style={{ width: '100%' }}
              disabled={'director' === userRole()}
              value={selectedInstitutionType}
              allowClear={true}
              onChange={filterInstitutionsByTypeId}>
              {institutionsType &&
                institutionsType.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
          <Col span={8}>
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              size="large"
              disabled={'director' === userRole() || !selectedInstitutionType}
              value={selectedInstitution?.id}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder={dictionary?.SelectInstitutionOrSearch[language]}
              allowClear
              treeDefaultExpandAll
              onChange={onSelectInstitution}
              filterTreeNode={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}>
              {groupedInstitutions &&
                Object.keys(groupedInstitutions).map((key) => {
                  return (
                    <TreeNode title={key} key={`city${key}`} disabled>
                      {groupedInstitutions[key].map((value) => {
                        return <TreeNode value={value.id} key={value.id} title={value.name} />;
                      })}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          </Col>
          <Col span={8}>
            <Select
              placeholder={dictionary?.Teachers[language]}
              size="large"
              style={{ width: '100%' }}
              allowClear={true}
              value={selectedTeacher?.id}
              disabled={!selectedInstitutionType || !selectedInstitution}
              onChange={onSelectTeacher}>
              {teachers &&
                teachers.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {`${el.lastName} ${el.firstName} ${el.middleName}`}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
        </Row>
        {!selectedTeacher && <Empty style={{ marginTop: '100px' }} />}
        {!!selectedTeacher && (
          <TeachersInfo
            selectedTeacher={selectedTeacher}
            setSelectedTeacher={setSelectedTeacher}
            edit={edit}
            setEdit={setEdit}
            institutions={institutions}
            classes={classes}
            filterInstitutionsByTypeId={filterInstitutionsByTypeId}
            selectedInstitutionType={selectedInstitutionType}
            onSelectInstitution={onSelectInstitution}
            onSelectTeacher={onSelectTeacher}
          />
        )}
      </TabPane>
      <TabPane tab={`${dictionary?.ActivatingTeachers[language]}`} key="3">
        <Row style={{ marginTop: '30px' }} gutter={16}>
          <Col span={12}>
            <Select
              placeholder={dictionary?.InstitutionType[language]}
              size="large"
              style={{ width: '100%' }}
              disabled={'director' === userRole()}
              value={selectedInstitutionType}
              allowClear={true}
              onChange={filterInstitutionsByTypeId}>
              {institutionsType &&
                institutionsType.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
          <Col span={12}>
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              size="large"
              disabled={'director' === userRole() || !selectedInstitutionType}
              value={selectedInstitution?.id}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder={dictionary?.SelectInstitutionOrSearch[language]}
              allowClear
              treeDefaultExpandAll
              onChange={onSelectInstitution}
              filterTreeNode={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}>
              {groupedInstitutions &&
                Object.keys(groupedInstitutions).map((key) => {
                  return (
                    <TreeNode title={key} key={`city${key}`} disabled>
                      {groupedInstitutions[key].map((value) => {
                        return <TreeNode value={value.id} key={value.id} title={value.name} />;
                      })}
                    </TreeNode>
                  );
                })}
              )
            </TreeSelect>
          </Col>
        </Row>
        <TeachersSwitcher
          setActive={setActive}
          setAdded={setAdded}
          teachers={teachers}
          setTeachers={setTeachers}
        />
      </TabPane>
    </Tabs>
  );
};

export default Teachers;
